import { useLocation } from "@tanstack/react-router";
import { type PropsWithChildren, useEffect } from "react";

import { ANALYTIC_EVENTS, useAnalytics } from "@/libs/analytics";

export const PageViewTrackingProvider = ({ children }: PropsWithChildren) => {
  const location = useLocation();
  const { sendEvent } = useAnalytics();

  useEffect(() => {
    const timeout = setTimeout(() => {
      sendEvent(ANALYTIC_EVENTS.ACTIVITY_PAGE_VIEWED, {
        current_url_path: location.pathname,
      });
    }, 1000);
    return () => {
      clearTimeout(timeout);
    };
  }, [location.pathname]);

  return children;
};
